<template>
  <span class="badge-plus-icon">PLUS</span>
</template>

<style scoped lang="scss">
@use "assets/styles/global/variables" as v;

.badge-plus-icon {
  padding: 2px 5px;
  align-self: center;
  border-radius: 15px;
  color: #FFFFFF;
  background-color: #F86C25;
  font-weight: 500;
  font-size: 8px;

  @media screen and (min-width: v.$tablet) {
    font-size: 12px;
  }

  @media screen and (min-width: v.$desktop) {
    font-size: 16px;
    padding: 2px 8px;
  }
}
</style>